import { AfterViewChecked, Directive, ElementRef, HostBinding, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appExternallinksdirective]'
})
export class ExternallinksdirectiveDirective implements AfterViewChecked {
  constructor(private el: ElementRef) { }

  ngAfterViewChecked() {
    Array.from(this.el.nativeElement.querySelectorAll('a'))
      .forEach((el: any) => {
        el.setAttribute('target', '_blank');
      });
  }
}
//  {

//   @HostBinding('attr.rel') relAttr = '';
//   @HostBinding('attr.target') targetAttr = '';
//   @HostBinding('attr.href') hrefAttr = '';
//   @Input() href: string;

//   constructor(@Inject(PLATFORM_ID) private platformId: string) { }

//   ngOnChanges() {
//     this.hrefAttr = this.href;

//     if (this.isLinkExternal()) {
//       this.relAttr = 'noopener';
//       this.targetAttr = '_blank';
//     }
//   }

//   private isLinkExternal() {
//     return isPlatformBrowser(this.platformId) && !this.href.includes(location.hostname);
//   }
// }